/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginTokens } from '../../models/login-tokens';
import { ProfileInviteNotExistingUser } from '../../models/profile-invite-not-existing-user';

export interface InviteNotExistingUserToProfile$Params {
  id: number;
      body: ProfileInviteNotExistingUser
}

export function inviteNotExistingUserToProfile(http: HttpClient, rootUrl: string, params: InviteNotExistingUserToProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginTokens>> {
  const rb = new RequestBuilder(rootUrl, inviteNotExistingUserToProfile.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginTokens>;
    })
  );
}

inviteNotExistingUserToProfile.PATH = '/rest/profile/{id}/invite';
